import styled from "styled-components";

const bp = { md: "768px" };

export const PageWrap = styled.div`
  background: transparent;
  padding-top: 0px;
`;

export const MenuLayout = styled.div`
  max-width: 1320px;
  margin: 0 auto;
  padding: 22px 16px;

  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 28px;
  align-items: start;

  @media (max-width: ${bp.md}) {
    padding: 16px 12px;
    grid-template-columns: 1fr;
    gap: 14px;
  }
`;

export const LeftCol = styled.aside`
  align-self: start;
`;

export const RightCol = styled.section`
  min-height: 280px;
`;

export const DesktopOnly = styled.div`
  display: block;
  @media (max-width: ${bp.md}) {
    display: none;
  }
`;
